
export const ElsaPurchaseStatus = {
	Accepted: 1,
	Rejected: 5,
	Pending: 10,
}